var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-div text-xs-left" },
    [
      _c(
        "div",
        { staticClass: "container-div" },
        [
          _c(
            "x-badge",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.close,
                  expression: "close",
                },
              ],
              class: { "shake animated": _vm.newTasksReceived },
              attrs: { color: "secondary", overlap: "" },
              scopedSlots: _vm._u([
                {
                  key: "badge",
                  fn: function () {
                    return [
                      _c("span", [_vm._v(_vm._s(_vm.formatMyTasksCount()))]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "x-btn",
                {
                  attrs: { icon: "", fab: "", color: "white" },
                  on: {
                    click: function ($event) {
                      return _vm.openClose()
                    },
                  },
                },
                [_c("x-icon", [_vm._v("notifications")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "x-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          staticClass: "my-tasks-list-container",
        },
        [
          _c("div", { staticClass: "tasks-title" }, [_vm._v("Tasks")]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "x-data-table",
                {
                  staticClass: "fit-to-width no-row-hover",
                  attrs: {
                    headers: _vm.tableHeaders,
                    items: _vm.tasks,
                    "hide-actions": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "items",
                        fn: function (props) {
                          return _vm.$root.userCan("view tasks")
                            ? [
                                _c("tr", [
                                  _c("td", [_vm._v(_vm._s(props.item.name))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.formatDate(props.item.due_by)
                                        ) +
                                        "\n                            "
                                    ),
                                    _vm.isOverdue(props.item.due_by)
                                      ? _c("i", {
                                          staticClass: "warning color-overdue",
                                        })
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "tasks-view",
                                              params: { id: props.item.id },
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "arrow_right",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            : undefined
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c(
                    "template",
                    { slot: "no-data" },
                    [
                      !_vm.tableLoading
                        ? _c(
                            "h5",
                            { staticClass: "error-message text-xs-center" },
                            [_vm._v(_vm._s(_vm.noResultsMessage))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("loader"),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }